// This file was generated using `pay js:run gql-v1 --type=fragment --name=StripeLegalEntityIndividualArk --dir=path/to/dir`.
// To generate yours, do not copy and paste; use the command above instead. Do not delete this comment.

/* eslint-disable @stripe-internal/data-v1/camel-case-alias */

import {gql} from '@sail/data';

import type {GraphQlDocument, GraphQlFragmentUnion} from '@sail/data';
import type {
  Exact,
  OpenapiLegalEntityIndividualObjectFieldType,
  OpenapiLegalEntityIndividualPoliticalExposureEnum,
} from '@stripe-internal/data-v1/schema/types';
import type {V1PermissionToken} from '@stripe-internal/data-v1/types';
import {legalEntityAddressArkFragment} from './legalEntityAddressArkFragment';
import {legalEntityJapanAddressArkFragment} from './legalEntityJapanAddressArkFragment';
import {personFutureRequirementsArkFragment} from './personFutureRequirementsArkFragment';
import {personRelationshipArkFragment} from './personRelationshipArkFragment';
import {personRequirementsArkFragment} from './personRequirementsArkFragment';
import {legalEntityPersonVerificationArkFragment} from './legalEntityPersonVerificationArkFragment';

import type {LegalEntityAddressArkFragmentData} from './legalEntityAddressArkFragment';
import type {LegalEntityJapanAddressArkFragmentData} from './legalEntityJapanAddressArkFragment';
import type {PersonFutureRequirementsArkFragmentData} from './personFutureRequirementsArkFragment';
import type {PersonRelationshipArkFragmentData} from './personRelationshipArkFragment';
import type {PersonRequirementsArkFragmentData} from './personRequirementsArkFragment';
import type {LegalEntityPersonVerificationArkFragmentData} from './legalEntityPersonVerificationArkFragment';

const doc = gql`
  fragment StripeLegalEntityIndividualArkFragment on OpenapiLegalEntityIndividual {
    account
    address {
      ...LegalEntityAddressArkFragment
    }
    address_kana {
      ...LegalEntityJapanAddressArkFragment
    }
    address_kanji {
      ...LegalEntityJapanAddressArkFragment
    }
    birth_city
    birth_country
    created
    dob {
      day
      month
      year
    }
    email
    first_name
    first_name_kana
    first_name_kanji
    full_name
    full_name_aliases
    future_requirements {
      ...PersonFutureRequirementsArkFragment
    }
    gender
    id
    id_number
    id_number_keyed_in
    id_number_type
    id_number_country
    id_number_last_4
    id_number_provided
    id_number_secondary_provided
    last_name
    last_name_kana
    last_name_kanji
    maiden_name
    nationality
    object
    personal_id_number_country
    personal_id_number_provided
    phone
    political_exposure
    registered_address {
      ...LegalEntityAddressArkFragment
    }
    relationship {
      ...PersonRelationshipArkFragment
    }
    requirements {
      ...PersonRequirementsArkFragment
    }
    ssn_last_4
    ssn_last_4_provided
    verification {
      ...LegalEntityPersonVerificationArkFragment
    }
  }

  ${legalEntityAddressArkFragment}
  ${legalEntityJapanAddressArkFragment}
  ${personFutureRequirementsArkFragment}
  ${personRelationshipArkFragment}
  ${personRequirementsArkFragment}
  ${legalEntityPersonVerificationArkFragment}
`;

export const stripeLegalEntityIndividualArkFragment: StripeLegalEntityIndividualArkFragmentDocument =
  doc;

// THIS IS AUTOGENERATED CODE, DO NOT EDIT AS YOUR CHANGES WILL BE BLOWN AWAY
// Regenerate it using eslint in fix mode.

export type StripeLegalEntityIndividualArkFragmentData = {
  readonly __typename: 'OpenapiLegalEntityIndividual';
  readonly account: string;
  readonly birth_city: string | null;
  readonly birth_country: string | null;
  readonly created: number;
  readonly email: string | null;
  readonly first_name: string | null;
  readonly first_name_kana: string | null;
  readonly first_name_kanji: string | null;
  readonly full_name: string | null;
  readonly full_name_aliases: ReadonlyArray<string> | null;
  readonly gender: string | null;
  readonly id: string;
  readonly id_number: string | null;
  readonly id_number_keyed_in: boolean | null;
  readonly id_number_type: string | null;
  readonly id_number_country: string | null;
  readonly id_number_last_4: string | null;
  readonly id_number_provided: boolean | null;
  readonly id_number_secondary_provided: boolean | null;
  readonly last_name: string | null;
  readonly last_name_kana: string | null;
  readonly last_name_kanji: string | null;
  readonly maiden_name: string | null;
  readonly nationality: string | null;
  readonly object: OpenapiLegalEntityIndividualObjectFieldType;
  readonly personal_id_number_country: string | null;
  readonly personal_id_number_provided: boolean | null;
  readonly phone: string | null;
  readonly political_exposure: OpenapiLegalEntityIndividualPoliticalExposureEnum | null;
  readonly ssn_last_4: string | null;
  readonly ssn_last_4_provided: boolean | null;
  readonly address: GraphQlFragmentUnion<
    {readonly __typename: 'OpenapiLegalEntityAddress'},
    [LegalEntityAddressArkFragmentData]
  > | null;
  readonly address_kana: GraphQlFragmentUnion<
    {readonly __typename: 'OpenapiLegalEntityJapanAddress'},
    [LegalEntityJapanAddressArkFragmentData]
  > | null;
  readonly address_kanji: GraphQlFragmentUnion<
    {readonly __typename: 'OpenapiLegalEntityJapanAddress'},
    [LegalEntityJapanAddressArkFragmentData]
  > | null;
  readonly dob: {
    readonly __typename: 'OpenapiLegalEntityDob';
    readonly day: number | null;
    readonly month: number | null;
    readonly year: number | null;
  } | null;
  readonly future_requirements: GraphQlFragmentUnion<
    {readonly __typename: 'OpenapiPersonFutureRequirements'},
    [PersonFutureRequirementsArkFragmentData]
  > | null;
  readonly registered_address: GraphQlFragmentUnion<
    {readonly __typename: 'OpenapiLegalEntityAddress'},
    [LegalEntityAddressArkFragmentData]
  > | null;
  readonly relationship: GraphQlFragmentUnion<
    {readonly __typename: 'OpenapiPersonRelationship'},
    [PersonRelationshipArkFragmentData]
  > | null;
  readonly requirements: GraphQlFragmentUnion<
    {readonly __typename: 'OpenapiPersonRequirements'},
    [PersonRequirementsArkFragmentData]
  > | null;
  readonly verification: GraphQlFragmentUnion<
    {readonly __typename: 'OpenapiLegalEntityPersonVerification'},
    [LegalEntityPersonVerificationArkFragmentData]
  > | null;
};

export type StripeLegalEntityIndividualArkFragmentVariables = Exact<{
  [key: string]: never;
}>;

const stripeLegalEntityIndividualArkFragmentPermissions = {
  ...legalEntityAddressArkFragment.permissions,
  ...legalEntityJapanAddressArkFragment.permissions,
  ...legalEntityPersonVerificationArkFragment.permissions,
  ...personFutureRequirementsArkFragment.permissions,
  ...personRelationshipArkFragment.permissions,
  ...personRequirementsArkFragment.permissions,
} as const;

doc.permissions = stripeLegalEntityIndividualArkFragmentPermissions;

export type StripeLegalEntityIndividualArkFragmentPermissions =
  V1PermissionToken<typeof stripeLegalEntityIndividualArkFragmentPermissions>;

export type StripeLegalEntityIndividualArkFragmentDocument = GraphQlDocument<
  StripeLegalEntityIndividualArkFragmentData,
  StripeLegalEntityIndividualArkFragmentVariables,
  StripeLegalEntityIndividualArkFragmentPermissions
>;
